import React from 'react';
import { Modal } from 'bootstrap';
import { ContentSlider } from '../../shared/carousel';
import { customerSayInfo } from './customerSaySettings';

const CustomerSaySection = (settings) => {
    const [selectedItem, setSelectedItem] = React.useState({});
    const modalId = "customerSayModal";

    const renderItemTemplate = (item) => (
        <div className="col-12 col-md-6 col-lg-4 p-2 d-flex">
            <div className="card card-glass flex-fill h-100">
                <div className="card-body d-flex flex-column">
                    <div className="row">
                        <div className="col-auto">
                            <img src={item.avatar} alt={item.name} className="img-customer-avatar img-fluid rounded-circle" />
                        </div>
                        <div className="col">
                            <div className="fw-bold">{item.name}</div>
                            <div className="text-body-secondary">{item.title}</div>
                        </div>
                    </div>
                    <p className="mt-2 flex-grow-1">
                        {item.text.length > 150 ? (
                            <>
                                {item.text.substring(0, 147)}...
                                <a href="/"
                                    className="text-decoration-none"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        setSelectedItem(item);
                                        setTimeout(() => {
                                            const modal = new Modal(document.getElementById(modalId));
                                            modal.show();
                                        }, 0);
                                    }}>Read More</a>
                            </>
                        ) : (
                            item.text
                        )}
                    </p>
                </div>
            </div>
        </div>
    );

    const CustomerSayModal = (settings) => {
        return (
            <div className="modal fade" id={modalId} tabIndex="-1" aria-labelledby={modalId + 'Label'} aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-auto">
                                    <img src={selectedItem.avatar} alt={selectedItem.name} className="img-customer-avatar img-fluid rounded-circle" />
                                </div>
                                <div className="col">
                                    <div className="fw-bold">{selectedItem.name}</div>
                                    <div className="text-body-secondary">{selectedItem.title}</div>
                                </div>
                                <div className="col-auto">
                                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                </div>
                            </div>
                            <p className="mt-2">
                                {selectedItem.text}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="py-4 customer-say">
            <div className="container">
                <div className="row">
                    <div className="col">
                        <span className="section-title section-title-highlight">Testimonials</span>
                        <span className="section-title d-none d-lg-inline-block">What our customers say</span>
                    </div>
                </div>
                <div className="row mt-3">
                    <ContentSlider
                        items={customerSayInfo.items}
                        itemCountToShow={3}
                        renderItemTemplate={renderItemTemplate}
                        showMoreUrl="/testimonials"
                        showMoreText="Show More" />
                    <CustomerSayModal {...settings} />
                </div>
            </div>
        </div>
    );
};

export default CustomerSaySection;
